import { ICTAFeature } from '@models/ICTAFeature';
import Banner from '@molecules/Banner/Banner';

const CtaFeature = (props: ICTAFeature) => (
  <Banner {...props} dataTestId="CT-29-Cta-Feature" />
);

export default CtaFeature;
